import LoadingIcon from "./components/LoadingIcon";

interface LoadingProps {
  message?: string;
}

export default function Loading({ message }: LoadingProps) {
  return (
    <main className="flex flex-1 flex-col items-center justify-center py-12">
      <LoadingIcon />

      {message && (
        <h1 className="mt-8 text-[38px] font-bold leading-[48px]">{message}</h1>
      )}
    </main>
  );
}
